import {
	TicketDTO,
	TicketDivisionDTO,
	CreateTicketDivisionRequest,
	CreateTicketDivisionResponse,
	MoveOneToRightTicketDivisionRequest,
	MoveOneToRightTicketDivisionResponse,
	TicketLineDTO,
	MoveOneToLeftTicketDivisionRequest,
	MoveOneToLeftTicketDivisionResponse,
	MoveOneTableCompanionToRightTicketDivisionRequest,
	MoveOneTableCompanionToRightTicketDivisionResponse,
	MoveOneTableCompanionToLeftTicketDivisionRequest,
	MoveOneTableCompanionToLeftTicketDivisionResponse,
	BeginPartialTicketClosingRequest,
	BeginPartialTicketClosingResponse,
	ClosingQuantityDTO,
	CancelClosingTicketRequest,
	EndPartialTicketClosingRequest,
	MoveTicketRequest,
	TicketLocationDTO,
	MoveTicketResponse,
	DivideEvenlyTicketDivisionRequest,
	DivideEvenlyTicketDivisionResponse,
	MoveOnePartToRightTicketDivisionRequest,
	MoveOnePartToRightTicketDivisionResponse
} from 'core/api';
import { Bus } from 'core/infrastructure';

const process = Bus.buildProcessFn('/bus/');

export async function createDivision(ticket: TicketDTO): Promise<TicketDivisionDTO> {
	const request = new CreateTicketDivisionRequest({ ticketId: ticket.Id });
	return process(request, (response: CreateTicketDivisionResponse) => response.Division);
}

export async function moveOneUnitToRight(division: TicketDivisionDTO, line: TicketLineDTO): Promise<TicketDivisionDTO> {
	const request = new MoveOneToRightTicketDivisionRequest({ division, line });
	return process(request, (response: MoveOneToRightTicketDivisionResponse) => response.Division);
}

export async function moveOnePartToRight(division: TicketDivisionDTO, line: TicketLineDTO, numberOfParts: number): Promise<TicketDivisionDTO> {
	const request = new MoveOnePartToRightTicketDivisionRequest({ division, line, numberOfParts });
	return process(request, (response: MoveOnePartToRightTicketDivisionResponse) => response.Division);
}


export async function divideEvenly(division: TicketDivisionDTO, numberOfParts: number): Promise<TicketDivisionDTO> {
	const request = new DivideEvenlyTicketDivisionRequest({ division, numberOfParts });
	return process(request, (response: DivideEvenlyTicketDivisionResponse) => response.Division);
}

export async function moveOneUnitToLeft(division: TicketDivisionDTO, line: TicketLineDTO): Promise<TicketDivisionDTO> {
	const request = new MoveOneToLeftTicketDivisionRequest({ division, line });
	return process(request, (response: MoveOneToLeftTicketDivisionResponse) => response.Division);
}

export async function moveOneTableCompanionToRight(division: TicketDivisionDTO): Promise<TicketDivisionDTO> {
	const request = new MoveOneTableCompanionToRightTicketDivisionRequest({ division });
	return process(request, (response: MoveOneTableCompanionToRightTicketDivisionResponse) => response.Division);
}

export async function MoveOneTableCompanionToLeft(division: TicketDivisionDTO): Promise<TicketDivisionDTO> {
	const request = new MoveOneTableCompanionToLeftTicketDivisionRequest({ division });
	return process(request, (response: MoveOneTableCompanionToLeftTicketDivisionResponse) => response.Division);
}

export async function beginClosingTicket(originalTicketId: number, closingQuantities: ClosingQuantityDTO[], closingTableCompanions: Nullable<number>): Promise<TicketDTO> {
	const request = new BeginPartialTicketClosingRequest({
		originalTicketId,
		closingQuantities,
		closingTableCompanions
	});

	return process(request, (response: BeginPartialTicketClosingResponse) => response.Ticket);
}

export async function cancelClosingTicket(closingTicketId: number, originalTicketId: number): Promise<void> {
	const request = new CancelClosingTicketRequest({
		closingTicketId,
		originalTicketId
	});

	await process(request);
}

export async function endClosingTicket(originalTicketId: number, closingTicketId: number, closingQuantities: ClosingQuantityDTO[], originalTableCompanions: Nullable<number>): Promise<void> {
	const request = new EndPartialTicketClosingRequest({
		originalTicketId,
		closingQuantities,
		closingTicketId,
		originalTableCompanions
	});


	return process(request);
}

export async function moveTicket(ticket: TicketDTO, keepPrices: boolean, location: TicketLocationDTO): Promise<TicketDTO> {
	const request = new MoveTicketRequest({ sourceTicketId: ticket.Id, keepPrices, targetLocation: location, targetTicketId: null });
	return process(request, (response: MoveTicketResponse) => response.Ticket);
}